<template>
  <div class="shopLists shopOptions">
    <div class="optionFilter">
      <span v-if="hasPosOption" class="checkbox">
        <input type="checkbox" id="display_sync_pos_options" v-model="displayShopPosOptions">
        <label for="display_sync_pos_options">연동하여 생성된 옵션 보기</label>
      </span>
      <input type="text" class="input sizeL searchInput" placeholder="option name or title" v-model="searchInput">
    </div>
    <div class="listGrid">
      <button type="button" class="item addItem"
        @click="openCreateOption('new')"></button>
      <div
        v-for="(item, index) in filteredList"
        :key="index"
        class="item"
        :class="{isBaseShopPos: item.isBaseShopPos}"
        @click="openCreateOption(item.id)">
        <div class="name">{{ item.title }}</div>
        <div class="itemInfo">{{ locale.option_items }}: {{ item.optItemCount }}</div>
        <div class="info">
          <p>{{ locale.table_updateat }}: {{ dateFormat(item.updateat) }}</p>
          <p>{{ locale.table_createat }}: {{ dateFormat(item.createat) }}</p>
        </div>
      </div>
    </div>
    <CreateOption
      v-if="createOption"
      :id="createOption"
      :locale="locale"
      :mustPosSync="mustPosSync"
      @reload="getShopStoreOptionList"
      @close="closeCreateOption" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DATE from '@/common/date'
import CreateOption from './CreateOption'
import regExp from '@/common/regExp'

export default {
  name: 'ShopOption',
  props: [
    'locale'
  ],
  components: {
    CreateOption
  },
  computed: {
    defaultLang () {
      const langInfo = this.$store.state.setting.lang
      return langInfo.default
    },
    hasPosOption () {
      return this.list.filter(option => option.isBaseShopPos).length > 0
    },
    filteredList () {
      const hasPosOption = this.hasPosOption
      const displayShopPosOptions = this.displayShopPosOptions
      const filteredWord = regExp.replaceAllEmpty(this.searchInput)
      function matchesSearch(item, searchInput) {
        // option title 또는 id에 포함되면 리턴
        if (
          regExp.replaceAllEmpty(item.title).includes(searchInput)
        ) {
          return true
        }
        // option name 객체의 모든 값에 대해 포함되는 부분이 있으면 리턴
        for (const lang in item.name) {
          if (regExp.replaceAllEmpty(item.name[lang]).includes(searchInput)) {
            return true
          }
        }
        // 일치 항목이 없음
        return false
      }
      return this.list.filter(option => {
        const passPosFilter = !(hasPosOption && !displayShopPosOptions && option.isBaseShopPos)
        const passSearchFilter = matchesSearch(option, filteredWord)
        return passPosFilter && passSearchFilter
      })
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
      list: [],
      createOption: null,
      mustPosSync: false,
      searchInput: '',
      displayShopPosOptions: false
    }
  },
  methods: {
    async init () {
      await this.getShopStoreOptionList()
    },
    dateFormat (isoString) {
      return DATE.toString(isoString)
    },
    async getShopStoreOptionList () {
      this.$store.commit('onLoading', true)
      // const getShopPageList = await this.$store.dispatch('shop/getShopPageList')
      const getOptionList = await this.$store.dispatch('shop/getShopStoreOptionList')
      const optionsList = getOptionList?.message?.option
      const mustPosSync = getOptionList?.message?.mustPosSync
      if (optionsList) {
        this.list = optionsList.map(item => {
          return {
            ...item,
            title: item.title || item.name[this.defaultLang]
          }
        })
      }
      if (mustPosSync) this.mustPosSync = mustPosSync
      this.$store.commit('onLoading', false)
    },
    openCreateOption (id) {
      this.createOption = id
    },
    closeCreateOption () {
      this.createOption = false
    },
    checkItem (e) {
      e.preventDefault()
      e.stopPropagation()
    }
  }
}
</script>

<style lang="scss" scoped>
.optionFilter {
  display: flex;
  align-items: center;
  padding: 8px 30px;
  margin-bottom: 4px;
  border: 1px solid $color-lgrey2;
  border-radius: 4px;
  background-color: $color-white;
  .checkbox {
    margin-right: 30px;
  }
}
</style>
